import $ from 'jquery';
import {Easings, smoothy} from "../Libraries/smoothy";

const $backToTop = $('.back-to-top');

$backToTop.on('click', function () {
    smoothy(0, 1000, Easings.easeOutQuint);
});

$(document).on('scroll', function () {
    if ($(window).width() > 768) {
        if ($(document).scrollTop() < 720) {
            $backToTop.addClass('hide');
        } else {
            $backToTop.removeClass('hide');
        }
    } else {
        if ($(document).scrollTop() < 420) {
            $backToTop.addClass('hide');
        } else {
            $backToTop.removeClass('hide');
        }
    }
});
